import { render, staticRenderFns } from "./ProjectSuccessfulComponent.vue?vue&type=template&id=6cb3354a"
import script from "./ProjectSuccessfulComponent.vue?vue&type=script&lang=js"
export * from "./ProjectSuccessfulComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectSuccessfulComponent.vue?vue&type=style&index=0&id=6cb3354a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports